import "./App.css";
import { RangeCalculator } from "./components";

function App() {
  return <RangeCalculator />;
}

export default App;
